<div class="exercise-preview-wrap" [ngClass]="{'in':startScreen}">
  <div class="preview-head">
    <div (click)="close();"><span>×</span></div>
  </div>

  <div class="preview-body">
    <img *ngIf="previewSource['fileType'] === 1 && isImgLoading" [src]="previewSource['fileUrl']"  alt="" />
    <iframe *ngIf="previewSource['fileType'] === 2" [src]="safeUrl"></iframe>
<!--    <embed *ngIf="previewSource['fileType'] === 2" [src]="safeUrl"  type="application/pdf" />-->
<!--    <object [data]="safeUrl" type="application/pdf"></object>-->
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-preview/preview.component.html